import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role'); // "staff" | "user"
  const staffRole = localStorage.getItem('staff_role'); // "FF Staff" | "Admin" | "Staff" | null
  const isFFStaff = role === 'staff' && staffRole === 'FF Staff';
  const location = useLocation();

  const isActive = (path) => (location.pathname === path ? 'active' : '');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('staff_role');
    localStorage.removeItem('crm_user_id');
    localStorage.removeItem('user_code');
    sessionStorage.removeItem('vault_signup_authenticated');
    window.location.href = '/userlogin';
  };

  // Menu options arrays
  const staffMenuItems = [
    { path: '/protected', label: 'Message Board' },
    { path: '/ports', label: 'Ports' },
    { path: '/send-messages', label: 'Send SMS' },
    { path: '/port-status', label: 'Port Status' },
    { path: '/advice-passwords', label: 'Advice' },
    { path: '/advice-passwords-dashboard', label: 'Advice Dashboard' },
    { path: '/user-gateways', label: 'User Gateways' },
    { path: '/tt-insights', label: 'TT Insights' },
    { path: '/user-signup', label: 'Sign Up' },
    { path: '/keep-alive', label: 'Keep Alive' },
    { path: '/sim-insertion-guide', label: 'SIM Guide' },
  ];

  const ffStaffMenuItems = [
    { path: '/protected', label: 'Message Board' },
    { path: '/ports', label: 'Ports' },
    { path: '/port-status', label: 'Port Status' },
    { path: '/advice-passwords', label: 'Advice' },
    { path: '/advice-passwords-dashboard', label: 'Advice Dashboard' },
    { path: '/sim-insertion-guide', label: 'SIM Guide' },
  ];

  const userMenuItems = [
    { path: '/user', label: 'My Dashboard' },
    { path: '/user-gateway', label: 'My Sim Box' },
  ];

  // Show nothing if not logged in
  if (!token) return null;

  const menuItems = role === 'user' ? userMenuItems : (isFFStaff ? ffStaffMenuItems : staffMenuItems);
  const linkStyle = role === 'staff' 
    ? { padding: '0.4rem 0.6rem', whiteSpace: 'nowrap' } 
    : {};

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-primary mb-4" style={{ position: 'sticky', top: 0, zIndex: 1030 }}>
      <div className="container">
        <Link className="navbar-brand" to={role === 'user' ? '/user' : '/protected'}>
          PhoneBox
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
          <div className="navbar-nav me-auto" style={{ flexWrap: 'nowrap', fontSize: '0.9rem' }}>
            {menuItems.map((item) => (
              <Link
                key={item.path}
                className={`nav-link ${isActive(item.path)}`}
                to={item.path}
                style={linkStyle}
              >
                {item.label}
              </Link>
            ))}
            {role === 'staff' && !isFFStaff && (
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={linkStyle}
                >
                  Onboarding
                </a>
                <ul
                  className="dropdown-menu bg-primary border-0"
                  style={{ fontSize: '0.9rem', minWidth: '12rem' }}
                >
                  <li>
                    <a
                      className="dropdown-item text-white"
                      href="https://forms.ttanalytics.net/admin/dashboard"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ padding: '0.4rem 0.75rem' }}
                    >
                      TT Forms
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item text-white"
                      href="https://forms.ttanalytics.net/terms"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ padding: '0.4rem 0.75rem' }}
                    >
                      Terms
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item text-white"
                      href="https://forms.ttanalytics.net/subaccount/request"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ padding: '0.4rem 0.75rem' }}
                    >
                      Subaccount Request
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item text-white"
                      href="https://forms.ttanalytics.net/privacy-policy"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ padding: '0.4rem 0.75rem' }}
                    >
                      Privacy Policy
                    </a>
                  </li>
                </ul>
              </li>
            )}
          </div>

          <div className="d-flex align-items-center gap-3">
            {role === 'staff' && !isFFStaff && (
              <Link
                className={`nav-link ${isActive('/archived-passwords')}`}
                to="/archived-passwords"
                style={{ padding: '0.4rem 0.6rem', whiteSpace: 'nowrap', color: 'rgba(255, 255, 255, 0.9)' }}
              >
                Archived
              </Link>
            )}
            <span className="badge bg-light text-dark">
              {role === 'user' ? 'User' : (staffRole || 'Staff')}
            </span>
            <button onClick={handleLogout} className="btn btn-light">
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;

